import { createSlice } from "@reduxjs/toolkit";

const rubricValues = createSlice({
    name: "rubricValues",
    initialState: {},
    selectors: { getRubricValues: state => state },
    reducers: {
        // Set expected rubric fields + remember any existing resume later values
        resetRubricValues: (_state, { payload }) => { return getInitialState(payload); },
        
        // Expected payload as { key: value }
        setRubricValue: (state, { payload }) => { state[payload.key] = payload.value; },
    }
});

// Helper functions
//
function getInitialState(payload = {}) {
    const { rubricConfig = {}, resumeLaterRubricValues } = payload;
    
    let initialState = getObjectWithEmptyStringRubricValues(rubricConfig);
    setRubricValues(initialState, resumeLaterRubricValues);

    return initialState;
}

function getObjectWithEmptyStringRubricValues(rubricConfig) {
    let initialState = { rubricKey: rubricConfig.rubricKey }; // Save key

    // Set each rubric item value to empty string so we know what to expect later for validation
    for (const rubricItem of rubricConfig.rubricItems ?? []) {
        initialState[rubricItem.label] = "";
    }
    
    return initialState;
}

function setRubricValues(initialState, resumeLaterRubricValues) {
    if (!(Object.keys(resumeLaterRubricValues ?? {}).length > 0)) { return; }
    
    for (const key of Object.keys(resumeLaterRubricValues)) {
        initialState[key] = resumeLaterRubricValues[key];
    }
}

export const selector = state => state.rubricValues;
export const { resetRubricValues, setRubricValue } = rubricValues.actions;
export default rubricValues.reducer;
